interface UnescapeResult {
  value?: string;
  errorIndex?: number;
}

export const escapeFormulaQuotedValue = (value: string): string => {
  return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
};

export const unescapeFormulaQuotedValue = (value: string): UnescapeResult => {
  let result = "";
  let index = 0;

  while (index < value.length) {
    const currentCharacter = value[index];
    if (currentCharacter === undefined) {
      break;
    }

    if (currentCharacter !== "\\") {
      result += currentCharacter;
      index++;
      continue;
    }

    const nextCharacter = value[index + 1];
    if (nextCharacter === undefined) {
      return { errorIndex: index };
    }

    result += nextCharacter;
    index += 2;
  }

  return { value: result };
};

const getPrecedingBackslashesCount = (value: string, index: number): number => {
  let backslashesCount = 0;
  let cursor = index - 1;

  while (cursor >= 0 && value[cursor] === "\\") {
    backslashesCount++;
    cursor--;
  }

  return backslashesCount;
};

export const isEscapedCharacter = (value: string, index: number): boolean => {
  return getPrecedingBackslashesCount(value, index) % 2 === 1;
};

export const findUnescapedQuoteForward = (value: string, startIndex: number): number => {
  for (let i = Math.max(startIndex, 0); i < value.length; i++) {
    if (value[i] === '"' && !isEscapedCharacter(value, i)) {
      return i;
    }
  }

  return -1;
};

export const findUnescapedQuoteBackward = (value: string, startIndex: number): number => {
  for (let i = Math.min(startIndex, value.length - 1); i >= 0; i--) {
    if (value[i] === '"' && !isEscapedCharacter(value, i)) {
      return i;
    }
  }

  return -1;
};

export const countUnescapedQuotes = (value: string): number => {
  let quotesCount = 0;

  for (let i = 0; i < value.length; i++) {
    if (value[i] === '"' && !isEscapedCharacter(value, i)) {
      quotesCount++;
    }
  }

  return quotesCount;
};
